import { forwardRef, useEffect, useState } from 'react';

import { InputText } from '@eneco/sparky';
import { InputTextProps } from '@eneco/sparky/types';

type MembershipNumberInputProps = Omit<InputTextProps, 'value' | 'onChange'> & {
  value?: string;
  onChange: (value: string) => void;
};

export const MembershipNumberInput = forwardRef<HTMLInputElement, MembershipNumberInputProps>(
  ({ value: controlledValue, onChange, ...props }, ref) => {
    const [internalValue, setInternalValue] = useState<string>(controlledValue ?? '');

    useEffect(() => {
      setInternalValue(controlledValue ?? '');
    }, [controlledValue]);

    const handleChange = (value: string) => {
      const unformattedMembershipNumber = value.replace(/-+/g, '');
      if (unformattedMembershipNumber.length > 9) return;
      if (value.slice(-1) === '-') value = value.slice(0, -1);

      const formattedValue = unformattedMembershipNumber.match(/.{1,3}/g)?.join('-') ?? '';

      setInternalValue(formattedValue);
      onChange(formattedValue);
    };

    return (
      <InputText ref={ref} value={internalValue} onChange={event => handleChange(event.target.value)} {...props} />
    );
  },
);
